import React from 'react'
import classNames from 'classnames'
import Container from '../container'
import Row from '../row'
import Col from '../col'
import { useUniqueIds } from '../../utilities/general'
import styles from './columns.module.scss'
import shared from '../shared.module.scss'

const ColumnsSlice = ({ slice }) => {
  const { items } = slice

  const {
    columns_gutter,
    columns_container_fluid,
    columns_margin_bottom,
    columns_text_color,
    columns_background_color,
    section_title,
  } = slice.primary

  const itemsWithIds = useUniqueIds( items )

  return (
    <section
      className={ classNames({
        [ shared.margin ]: columns_margin_bottom,
        [ shared.padding ]: columns_background_color,
      })}
      style={{
        color: columns_text_color,
        backgroundColor: columns_background_color,
      }}
    >
      <Container className={ styles.container } fluid={ columns_container_fluid }>
        
        { section_title.text && (
          <h2 className={ styles.title }>{ section_title.text }</h2>
        )}

        <Row gutter={ columns_gutter }>
          { !! itemsWithIds.length && itemsWithIds.map( item => (
            <Col
              key={ item.uniqueId }
              span={ item.columns_span }
              sm={ item.columns_span_small }
              md={ item.columns_span_medium }
              lg={ item.columns_span_large }
              xl={ item.columns_span_extra_large }
            >
              { item.columns_content.text && (
                <div dangerouslySetInnerHTML={{ __html: item.columns_content.html }} />
              )}
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  )
}

export default ColumnsSlice